import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { PageLoader } from "../components/Auth/PageLoader";

export const CallbackPage = () => {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/profile");
    }

    if (error) {
      // get parameters from the URL
      const params = new URLSearchParams(window.location.search);
      navigate(`/error?${params}`);
    }
  }, [isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="content-width-container">
        <PageLoader />
      </div>
    );
  }

  return (
    <div className="content-width-container">
      <PageLoader />
    </div>
  );
};
